// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__nKNYF","detailsBorder":"styles_detailsBorder__3TY1s"};